import { makeVar, useReactiveVar } from '@apollo/client';

const streamCryptoPaymentVar = makeVar<{
  [streamId: string]: {
    initiated: boolean;
    invoiceUrl?: string | null;
  };
}>({});

export const useStreamCryptoPaymentState = (streamId: string) => {
  return (
    useReactiveVar(streamCryptoPaymentVar)[streamId] || { initiated: false }
  );
};

export const updateStreamCryptoPaymentState = (
  streamId: string,
  update: Partial<{
    initiated: boolean;
    invoiceUrl: string;
  }>,
) => {
  const prevState = streamCryptoPaymentVar();
  streamCryptoPaymentVar({
    ...prevState,
    [streamId]: { ...prevState[streamId], ...update },
  });
};

export const removeStreamCryptoPayment = (streamId: string) => {
  const { [streamId]: _, ...rest } = streamCryptoPaymentVar();
  streamCryptoPaymentVar(rest);
};
